var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v(_vm._s(_vm.$t("privacy_poliy")))]),(_vm.language === 'de')?_c('PrivacyGerman'):_vm._e(),(_vm.language === 'en')?_c('PrivacyEnglish'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }